export const docCopy = {
  doc_layout_title: "学习 TypeScript 的起点",
  doc_layout_description:
    "找到针对 TypeScript 的入门项目：Angular、React 或者 Node.js 与 CLI。",
  doc_headline: "开始学习",
  doc_headline_5m_title: "5 分钟入门 TS",
  doc_headline_5m_blurb: "5 分钟了解语言",
  doc_headline_tooling_title: "TS 工具",
  doc_headline_tooling_blurb: "5 分钟了解工具",
  doc_headline_handbook_title: "手册",
  doc_headline_handbook_blurb: "TypeScript 语言参考",
  doc_headline_examples_title: "示例",
  doc_headline_examples_blurb: "全面的游乐场实践教程",
  doc_start_a_project: "开始一个项目",
  doc_start_a_project_desc:
    "由于 TypeScript 是 JavaScript 的超集，所以它没有默认的模板——他们太多了。相反，其他项目在他们自己的环境中具有自己的 TypeScript 引导模板。这些项目提供了包含 TypeScript 支持的模板。",
  doc_node_npm: "Node 和 npm",
  doc_node_npm_tsdx_blurb: "零配置构建 TypeScript 库。",
  doc_node_npm_oclif_blurb: "创建您用户喜爱的命令行工具",
  doc_node_npm_gluegun_blurb:
    "一个令人愉悦的工具，用于构建由 TypeScript 驱动的命令行应用程序。",
  doc_frameworks: "Web 框架",
  doc_frameworks_angular_blurb: "让编写优雅的程序充满乐趣",
  doc_frameworks_ember_blurb: "雄心勃勃的Web开发人员的框架",
  doc_frameworks_react_blurb: "一个用于构建用户界面的 JavaScript 库",
  doc_frameworks_vue_blurb: "渐进式 JavaScript 框架",
  doc_frameworks_ror_blurb: "约定优于配置的 Web 框架",
  doc_frameworks_asp_blurb: "用于构建现代的，基于云的，联网的应用程序的框架",
  doc_apis: "Node 接口",
  doc_apis_azure_blurb: "使用 VS Code 在数分钟内构建和部署",
  doc_apis_feather_blurb: "一个提供 REST 接口的实时应用框架",
  doc_apis_graphql_blurb: "在数分钟内启动您的 GraphQL 服务",
  doc_apis_nest_blurb: "一个渐进式的构建高效可扩展的服务端应用的 Node.js 框架",
  doc_apis_node_blurb: "TS 团队提供的一个引导模板",
  doc_apis_wechat_blurb: "在 TypeScript 中使用微信 JSSDK",
  doc_react: "React 项目",
  doc_react_create_blurb: "使用一条命令创建现代 web 应用",
  doc_react_gatsby_blurb: "帮助开发者构建高效的网站和应用",
  doc_react_next_blurb: "一个 React 框架",
  doc_react_razzle_blurb: "无需配置，为应用添加通用的服务端渲染",
  doc_react_toolchains_title: "建议的工具链",
  doc_react_toolchains_blurb: "来自 React 团队的建议",
  doc_apps: "构建应用",
  doc_apps_electron_blurb: "一个命令构建一个现代 web 应用",
  doc_apps_expo_blurb: "最快的构建应用的方案",
  doc_apps_react_native_blurb: "学习一次，在任何地方执行",
  doc_apps_native_script_blurb: "构建真正移动端本地应用的开源框架",
  doc_apps_make_code_blurb: "通过有趣的项目将计算机科学带给所有学生",
  doc_tooling: "工具",
  doc_tooling_babel_blurb: "现在即可使用下一代 JavaScript",
  doc_tooling_parcel_blurb: "快速，零配置的 Web 应用打包工具",
  doc_tooling_webpack_blurb: "将您的资源，脚本，图片和样式打包",
  doc_learn: "对 TypeScript 熟悉吗？",
  doc_learn_3_5_release_notes_title: "发布日志",
  doc_learn_3_5_release_notes_blurb: "3.5 发布日志",
  doc_learn_handbook_blurb: "TypeScript 语言参考",
  doc_learn_d_ts_title: "d.ts 指南",
  doc_learn_d_ts_blurb: "学习如何定义 JS 的形状",
  doc_learn_playground_blurb: "在线查看并分享 TypeScript",
  nav_: {
    id: "foo",
    defaultMessage: "foo",
  },
}
